const BACKGROUND_WORKER_ID = "obhaigpnhcioanniiaepcgkdilopflbb";
const GX_CLIENT_ID = 7;
const MessageTypes = {
    PLAY_SOUND: 500,
};
if (typeof chrome !== "undefined" && chrome.runtime?.connect) {
    chrome.runtime?.connect?.(BACKGROUND_WORKER_ID, {
        name: String(GX_CLIENT_ID),
    });
}
export const playSound = (name, pan = 0.0) => {
    if (!chrome.runtime?.sendMessage) {
        throw new Error("chrome.runtime.sendMessage is not available");
    }
    chrome.runtime.sendMessage(BACKGROUND_WORKER_ID, {
        client: GX_CLIENT_ID,
        data: {
            type: MessageTypes.PLAY_SOUND,
            // name is for backward compatibility
            name: name === "HOVER_UP" ? "hover" : name.toLowerCase(),
            soundName: name,
            pan,
        },
    });
};
